import { OTPVerification } from "../OTPVerification";
import { EmailForm } from "../EmailForm";
import { OAuthButton } from "../OAuthButton";
import { AuthFormCardSeparator } from "../AuthFormCard";
import { AuthCardFooter, AuthCardHeader } from "../AuthCard";

// // // //

export function InlineAuthenticationModalContent(props: {
    currentStep: "auth" | "otp";
    isLoading: boolean;
    userEmail: string;
    onGoogleSignIn: () => void;
    onEmailSubmit: (email: string) => void;
    onOTPSubmit: (code: string, email: string) => void;
}) {
    const {
        currentStep,
        isLoading,
        userEmail,
        onGoogleSignIn,
        onEmailSubmit,
        onOTPSubmit,
    } = props;

    if (currentStep === "auth") {
        return (
            <div className="py-8 px-8 bg-card">
                <AuthCardHeader
                    title="Create your RWA.xyz account"
                    description={
                        <>
                            Thank you for exploring RWA.xyz. Please create a
                            free account to continue exploring real-world asset
                            tokenization.
                        </>
                    }
                />

                <div className="mt-5 sm:mt-8 space-y-4 sm:space-y-6">
                    <EmailForm
                        disabled={isLoading}
                        onSubmit={onEmailSubmit}
                        showLoading={isLoading}
                        isWorkEmailOnly={true}
                    />

                    <AuthFormCardSeparator />

                    <OAuthButton
                        provider="google"
                        variant="register"
                        disabled={isLoading}
                        loading={false}
                        onClick={onGoogleSignIn}
                    />

                    <AuthCardFooter variant="register" />
                </div>
            </div>
        );
    }

    if (currentStep === "otp") {
        return (
            <div className="py-8 px-8 bg-card">
                <div className="text-center mb-6">
                    <h2 className="text-center text-xl font-normal tracking-tight text-slate-800 sm:text-[1.375rem]">
                        Check your email
                    </h2>
                    <p className="mt-2 text-center text-sm leading-relaxed text-secondary-foreground">
                        A sign-in code has been sent to your email address.
                    </p>
                </div>

                <OTPVerification
                    email={userEmail}
                    isLoading={isLoading}
                    onSubmit={onOTPSubmit}
                />
            </div>
        );
    }

    return null;
}
